import { render, staticRenderFns } from "./InvoiceItemList.vue?vue&type=template&id=1ccdcc28&scoped=true&"
import script from "./InvoiceItemList.vue?vue&type=script&lang=ts&"
export * from "./InvoiceItemList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccdcc28",
  null
  
)

export default component.exports